// TOUR-8 — Training mode consumption (roleplay practice path).

import type { FireflyTourArtifact } from "../tourTypes";

export const TRAINING_PRACTICE_TOUR_ID = "tour-training-practice";

/** @deprecated Use `TRAINING_PRACTICE_TOUR_ID` — kept for completion-key migration. */
export const TRAINING_TOUR_ID = TRAINING_PRACTICE_TOUR_ID;

export const TRAINING_PRACTICE_TOUR: FireflyTourArtifact = {
  id: TRAINING_PRACTICE_TOUR_ID,
  version: 1,
  defaultIntent: "teaching",
  intents: [
    "training tour",
    "training practice tour",
    "how do i practice a sales call",
    "how do i do roleplay",
    "practice a sales call",
    "sales roleplay tour",
    "how do i use training",
    "show me training mode",
    "roleplay practice tour",
  ],
  bucketRelevance: ["sales", "manager"],
  requiredRoles: ["sales", "trainer"],
  steps: [
    {
      id: "nav-training",
      target: { mode: "leads", anchorId: "mode-nav-training", scrollIntoView: true },
      deferModeNavigation: true,
      skipWhenCurrentMode: "training",
      copy: [
        {
          roles: ["sales"],
          title: "Open Training",
          body: "Practice roleplay scenarios here before real lot conversations. Tap Training in the sidebar (or bottom bar on mobile).",
        },
        {
          roles: ["trainer"],
          title: "Open Training (coach view)",
          body: "Reps run scenarios here — use this tour to walk the consumption path while you observe. Authors edit scenarios under Manager → Training Authoring.",
        },
      ],
      waitForClick: true,
    },
    {
      id: "roleplay-tab",
      target: { mode: "training", anchorId: "training-roleplay-tab", scrollIntoView: true },
      copy: {
        title: "Roleplay tab",
        body: "Start on Roleplay — AI customer simulations live here. Ask & policies is for KB search; Contacts is the directory lane.",
      },
      waitForClick: true,
    },
    {
      id: "scenario-picker",
      target: { mode: "training", anchorId: "training-scenario-list", scrollIntoView: true },
      copy: [
        {
          roles: ["sales"],
          title: "Pick a scenario",
          body: "Choose a scenario from the list — org, manufacturer-inherited, or platform examples your trainer published.",
        },
        {
          roles: ["trainer"],
          title: "Pick a scenario",
          body: "Same catalog reps see. Point trainees at Live org scenarios you published, or manufacturer/platform examples for demos.",
        },
      ],
      advanceOn: "next_button",
    },
    {
      id: "start-roleplay",
      target: { mode: "training", anchorId: "training-start-roleplay", scrollIntoView: true },
      copy: [
        {
          roles: ["sales"],
          title: "Start roleplay",
          body: "Tap Start roleplay when you are ready. Reply by typing or dictating; End & score when finished to see strengths and improvements.",
        },
        {
          roles: ["trainer"],
          title: "Start roleplay (demo)",
          body: "Run a session to show the flow — or let the rep drive. End & score surfaces rubric feedback trainers can discuss in Reviews.",
        },
      ],
      destructive: true,
    },
    {
      id: "ask-firefly",
      target: { mode: "training", anchorId: "ask-firefly", scrollIntoView: true },
      copy: [
        {
          roles: ["sales"],
          title: "Ask Firefly anytime",
          body: "Need capture or console help? Ask Firefly anytime — lead capture and sales console tours start from any Sales mode.",
        },
        {
          roles: ["trainer"],
          title: "Ask Firefly anytime",
          body: "Authoring scenarios? Ask for the training author tour from Manager → Training Authoring. Reps stay on this consumption path.",
        },
      ],
      advanceOn: "next_button",
    },
  ],
};

/** @deprecated Use `TRAINING_PRACTICE_TOUR` */
export const TRAINING_TOUR = TRAINING_PRACTICE_TOUR;
